/* mf-pack-offer.js — Accessories Pack offer in the cart drawer (v4, 25 Sep 2026).
   The checkbox toggles the pack in/out of the cart. State flips immediately
   (optimistic), then the theme's CartDrawer re-renders from section HTML via
   cart:refresh, which re-derives the ticked state from the real cart. */
(function () {
  if (customElements.get('mf-pack-offer')) return;

  const routes = () => (window.FoxTheme && FoxTheme.routes) || {};

  class MFPackOffer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    setState(btn, on) {
      const item = btn.closest('.mf-pack-offer__item');
      btn.setAttribute('aria-checked', String(on));
      if (item) item.classList.toggle('is-added', on);
      const label = btn.querySelector('.mf-pack-offer__label');
      if (label) label.textContent = on ? 'Added' : 'Add';
    }

    async onClick(e) {
      const btn = e.target.closest('.mf-pack-offer__toggle');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      const id = parseInt(btn.dataset.variantId, 10);
      if (!id) return;

      const wasOn = btn.getAttribute('aria-checked') === 'true';
      const turnOn = !wasOn;
      this.setState(btn, turnOn);
      btn.setAttribute('aria-busy', 'true');
      this.showError('');

      try {
        let res;
        if (turnOn) {
          res = await fetch((routes().cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
        } else {
          res = await fetch((routes().cart_update_url || '/cart/update') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [id]: 0 } }),
          });
        }
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not update your cart');

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));

        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: turnOn ? 'mf_pack_offer_add' : 'mf_pack_offer_remove', variant_id: id, placement: 'cart_drawer' });
        }
      } catch (err) {
        this.setState(btn, wasOn);
        this.showError(err.message || 'Something went wrong — please try again.');
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }

    showError(msg) {
      const el = this.querySelector('.mf-pack-offer__error');
      if (!el) return;
      el.textContent = msg;
      el.hidden = !msg;
    }
  }

  customElements.define('mf-pack-offer', MFPackOffer);
})();
